import { render, staticRenderFns } from "./StatusTag.vue?vue&type=template&id=41d85396&scoped=true&"
import script from "./StatusTag.vue?vue&type=script&lang=js&"
export * from "./StatusTag.vue?vue&type=script&lang=js&"
import style0 from "./StatusTag.vue?vue&type=style&index=0&id=41d85396&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41d85396",
  null
  
)

export default component.exports